import { IIconProps } from "~/types";
const DownloadIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 12v.75A2.25 2.25 0 0 0 5.25 15h7.5A2.25 2.25 0 0 0 15 12.75V12m-3-3-3 3m0 0L6 9m3 3V3"
      stroke="#313036"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default DownloadIcon;
